import React from 'react';
import {message} from 'antd';
import html2canvas from 'html2canvas';
import {WeaLocaleProvider, WeaTools, WeaDialog} from 'ecCom';

import Background from '../wea-portal-background/';

import './style/';
import Toolbar from './Toolbar';
import Layout from './Layout';
import { addContentPath } from '../util/pathUtil';

const getLabel = WeaLocaleProvider.getLabel;

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.getPortalLayout = this.getPortalLayout.bind(this);
        this.onAddElement = this.onAddElement.bind(this);
        this.onBackgroundChange = this.onBackgroundChange.bind(this);
        this.onLayoutChange = this.onLayoutChange.bind(this);
        this.onPreview = this.onPreview.bind(this);
        this.onSave = this.onSave.bind(this);
    }

    componentWillMount() {
        this.getPortalLayout(this.props);
    }

    shouldComponentUpdate(nextProps,nextState){
        if(nextProps.id == this.props.id && nextProps.layoutType == this.props.layoutType){
        }else{
            this.getPortalLayout(nextProps);
        }
        return true
    }

    render() {
        const {
            loading = true,
            previewVisible = false,
            id,
            isSetting,
            layoutType,
            background = {},
            layout = {},
            element = {},
            elementSettingProps={}
        } = this.state;

        if (loading) {
            return null;
        }

        return (
            <div className={`wea-portal-layout-container ${isSetting ? 'wea-portal-layout-setting' : ''}`}>
                {
                    isSetting && (
                        <div className="wea-portal-layout-toolbar">
                            <Toolbar ecId={`${this && this.props && this.props.ecId || ''}_Toolbar@q6viut`}
                                id={id}
                                background={background}
                                layout={layout}
                                onAddElement={this.onAddElement}
                                onBackgroundChange={this.onBackgroundChange}
                                onLayoutChange={this.onLayoutChange}
                                onPreview={this.onPreview}
                                onSave={this.onSave}
                            />
                        </div>
                    )
                }
                <div className="wea-portal-layout-content" style={isSetting ? {top: '54px'} : {}}>
                    <Background ecId={`${this && this.props && this.props.ecId || ''}_Background@dhyjvb`} background={background} onChange={this.onBackgroundChange}/>
                    <Layout ecId={`${this && this.props && this.props.ecId || ''}_Layout@8ibw3d`}
                        {...this.props}
                        ref={(layout) => this.layout = layout}
                        isSetting={isSetting}
                        layoutType={layoutType}
                        layout={layout}
                        element={element}
                        elementSettingProps={elementSettingProps}
                        onChange={this.onLayoutChange}
                    />
                </div>
                {
                    previewVisible && (
                        <WeaDialog ecId={`${this && this.props && this.props.ecId || ''}_WeaDialog@owhw1s`}
                            visible={true}
                            title={getLabel(221, '预览')}
                            icon="icon-coms-portal"
                            iconBgcolor='#1a57a0'
                            style={{width: document.body.clientWidth - 50, height: document.body.clientHeight - 100}}
                            onCancel={() => this.setState({previewVisible: false})}
                        >
                            <div className="wea-portal-layout-preview">
                                <Background ecId={`${this && this.props && this.props.ecId || ''}_Background@ycsk4v`} background={background} onChange={this.onBackgroundChange}/>
                                <Layout ecId={`${this && this.props && this.props.ecId || ''}_Layout@shu9ld`} isSetting={false} layoutType={layoutType} layout={layout} element={element}/>
                            </div>
                        </WeaDialog>
                    )
                }
            </div>
        );
    }

    getPortalLayout(props) {
        const {id, isSetting, layoutType} = props;
        const _isSetting = String(isSetting) === 'true';

        if (_isSetting) {
            window.onbeforeunload = () => {
                if (window.WeaPortalLayoutIsChanged) {
                    return getLabel(390948, '布局设置已发生更改，尚未保存，是否离开？');
                }
            }
        }

        // 登录前和登录后所请求的api不一样，因为登录前没有用户信息
        let api = '/api/loginportal/common/getPortalGridLayout';
        if (layoutType === 'theme') {
            api = '/api/portal/portalGridLayout/getPortalGridLayout';
        }

        this.setState({loading: true});
        WeaTools.callApi(api, 'GET', {id, layoutType}).then((result) => {
            let {background = {}, layout = {}, element = {},setting="{}",elementSettingProps="{}"} = result;
            if(setting == null || setting == ""){
                setting = "{}"
            }
            // 如果中间布局配置不存在，则初始化中间布局配置
            if (!layout.middle) {
                layout.middle = {
                    visible: true,
                    height: 0,
                    cellRows: 0,
                    cellCols: 20,
                    cellWidth: '5%',
                    cellHeight: 15,
                    cellMarginX: 10,
                    cellMarginY: 10
                };
            }

            // 如果允许前端手动切换背景，则需要从本地缓存获取背景数据
            const {allowToChange} = background;
            const _background = allowToChange ? WeaTools.ls.getJSONObj('wea_portal_background') || {} : {};

            this.setState({
                loading: false,
                id,
                isSetting: _isSetting,
                layoutType,
                background: {...background, ..._background},
                layout,
                element,
                setting:JSON.parse(setting),
                elementSettingProps: JSON.parse(elementSettingProps)
            });
        });
    }

    onAddElement(id, position) {
        const positionLayout = this.layout[`${position}Layout`];
        const onAddElement = positionLayout && positionLayout.onAddElement;
        onAddElement && onAddElement(id, position);
    }

    onBackgroundChange(background, isCustom) {
        if (isCustom) {
            this.setState({background});
            WeaTools.ls.set('wea_portal_background', JSON.stringify(background));
        } else {
            const element = this.layout.getElement();
            this.setState({background, element});
            window.WeaPortalLayoutIsChanged = true;
        }
    }

    onLayoutChange(obj) {
        const {layout} = this.state;
        const element = this.layout.getElement();

        this.setState({
            layout: {...layout, ...obj},
            element
        });

        window.WeaPortalLayoutIsChanged = true;
    }

    // onPreview() {
    //     const element = this.layout.getElement();
    //
    //     this.setState({
    //         previewVisible: true,
    //         element
    //     });
    // }
    
    onPreview() {
        const {id, layoutType} = this.props;
        let url = ''
        if(layoutType =='login'){
            url = `/wui/index.html?preview=true&loginTemplateId=${id}&loginTemplateType=ECustom#/`
        }else if(layoutType == 'theme'){
            url = `/wui/index.html?themeType=ECustom&templateId=${id}&from=static#/main`
        }
        window.open(addContentPath(url),"_blank");
    }

    onSave() {
        html2canvas($(".wea-portal-layout-content")[0],{
            // with: 118,
            // height: 68,
            // windowWidth: document.body.scrollWidth,
            // windowHeight: document.body.scrollHeight,
            allowTaint: true,
            useCORS: true,
            scale: 0.1,
            ignoreElements: (element) =>{
                if(element.className == 'data-html2canvas-ignore'){
                    return true
                }

            },
        }).then(function(canvas){
            const preview = canvas.toDataURL("image/png")
            this.savePreview(preview)

        }.bind(this),function(err){
            this.savePreview()
        }.bind(this))
        

    }

    savePreview = (preview)=>{
        const {id, background, layout,setting={}} = this.state;
        const element = this.layout.getElement();
        if(preview){
            setting.preview = preview
        }
        WeaTools.callApi('/api/portal/portalGridLayout/setPortalGridLayout', 'POST', {
            id,
            background: JSON.stringify(background),
            layout: JSON.stringify(layout),
            element: JSON.stringify(element),
            setting: JSON.stringify(setting)
        }).then((result) => {
            if (result.api_status) {
                message.success(getLabel(83551, '保存成功！'));
                window.WeaPortalLayoutIsChanged = false;
            } else {
                message.error(getLabel(84544, '保存失败！'));
            }
        });
    }
}

export default Index;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-portal-layout/index.js